/* GASSISA
=========================================================================================
 * Descripcion: Vista previa del ticket de ventas en texto, tal como se va a
 *              imprimir. Recibe las lineas ya decodificadas del binario ESC/POS
 *              (parseEscPosPreview) y las dibuja respetando alineacion, negrita
 *              y doble tamano.
 *
 *              Se usa en Parametros de Caja > Ticket (ticket de prueba) para
 *              validar el diseno sin registrar una venta.
 *
 * Historial de cambios:
 * ---------------------------------------------------------------------------------------
 *    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
 * ---------------------------------------------------------------------------------------
 *      1       | 20/10/2026 | Lic. José Luis Aragón Cervantes  | Creación
 *      2       | 21/10/2026 | Lic. José Luis Aragón Cervantes  | Escala real del layout
 * ---------------------------------------------------------------------------------------*/

import { Box, Dialog, DialogActions, DialogContent, DialogTitle, Button, Typography } from "@mui/material";
import { metricasPreviewTicket } from "../../settings/ticketPerfil";

export default function TicketPreview({
    abierto = false,
    titulo = "Vista previa del ticket",
    lineas = [],
    columnas = 32,
    calibracion,
    nota = "Vista previa con datos ficticios (2 partidas). No registra ninguna venta.",
    onCerrar,
}) {
    const metricas = metricasPreviewTicket(columnas, calibracion);
    const { anchoPx, anchoMm, fontSize, lineHeight, columnas: columnasEfectivas } = metricas;
    const altoLineaGrande = Math.max(lineHeight, fontSize * 2 * 1.2);

    return (
        <Dialog open={abierto} onClose={onCerrar} maxWidth="xs" fullWidth>
            <DialogTitle sx={{ fontSize: 15, fontWeight: "bold" }}>{titulo}</DialogTitle>
            <DialogContent>
                <Box sx={{ mt: 1, overflowX: "auto", overflowY: "auto", maxHeight: "58vh" }}>
                    <Box
                        sx={{
                            p: 1.5,
                            width: `${anchoPx}px`,
                            mx: "auto",
                            backgroundColor: "#fff",
                            border: "1px solid #ccc",
                            fontFamily: '"Courier New", Courier, monospace',
                            fontSize: `${fontSize}px`,
                            lineHeight: `${lineHeight}px`,
                            minHeight: 120,
                        }}
                    >
                        {lineas.length === 0 && (
                            <Typography variant="caption" color="text.secondary">Sin contenido para mostrar.</Typography>
                        )}
                        {lineas.map((linea, indice) => (
                            <Box
                                key={indice}
                                sx={{
                                    whiteSpace: "pre",
                                    minHeight: `${linea.large ? altoLineaGrande : lineHeight}px`,
                                    lineHeight: `${linea.large ? altoLineaGrande : lineHeight}px`,
                                    textAlign: linea.align === "center" ? "center" : linea.align === "right" ? "right" : "left",
                                    fontWeight: linea.bold ? "bold" : "normal",
                                    fontSize: linea.large ? `${fontSize * 2}px` : `${fontSize}px`,
                                }}
                            >
                                {linea.text || " "}
                            </Box>
                        ))}
                    </Box>
                </Box>
                <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 1 }}>
                    {nota}
                    Referencia visual: {columnasEfectivas} columnas ({(anchoMm / 10).toFixed(2)} cm).
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCerrar} color="primary">Cerrar</Button>
            </DialogActions>
        </Dialog>
    );
}
